module.exports = __webpack_public_path__ + "img/zd-down-3.618f5f2f.svg";